import { ReactNode } from "react";

type DataType = "date" | "number" | "string" | "boolean" | "string|number[]";

type ComparatorKey = "==" | ">=" | "<" | "!=" | "<" | ">"| "<=" | "between";

type TimeUnit = "s" | "m" | "h" | "ms";

type FilterValue<T> = { value: T | T[] } | { valueFrom: T; valueTo: T };

type NonRangeComparator = Exclude<ComparatorKey, "between">;

type FilterType = {
  key: string;
  category: DataType;
  path: (string | number)[];
  transform?: (value: any) => any;
  op: NonRangeComparator | "between";
};

type BaseFilter = FilterType & {
  title: string;
  component: string;
  labelTransform?: (value: any, deps: Record<string, any>) => any;
  label?: ReactNode;
  dependencies?: { key: string; path: (string | number)[] }[];
};

type GroupOptionType = {
  key: string;
  category: DataType;
  path: (string | number)[];
  transform?: (value: any[]) => {};
};

const comparators = {
  "==": function <T>(val: T, filterVal: T) {
    return val === filterVal;
  },
  "!=": function <T>(val: T, filterVal: T) {
    return val !== filterVal;
  },
  ">": function <T>(val: T, filterVal: T) {
    return val > filterVal;
  },
  ">=": function <T>(val: T, filterVal: T) {
    return val >= filterVal;
  },
  "<": function <T>(val: T, filterVal: T) {
    return val < filterVal;
  },
  "<=": function <T>(val: T, filterVal: T) {
    return val <= filterVal;
  },
  between: function <T>(val: T, filterVal: { valueFrom: T; valueTo: T }) {
    return val >= filterVal.valueFrom && val <= filterVal.valueTo;
  },
};

type SegmentCountType = {
  segmentCount:number;
  totalCount:number;
}


export type {SegmentCountType, BaseFilter, ComparatorKey, DataType, FilterType, NonRangeComparator, TimeUnit, FilterValue, GroupOptionType };
export {comparators};
